exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bc-navbar-loading-inner.loading {\n}\n.bc-navbar-loading-inner.loading:before{\n    display: block;\n    position: absolute;\n    content: \"\";\n    left: -200px;\n    width: 200px;\n    height: 5px;\n    animation-fill-mode: forwards;\n    background-color: #60a6ea;\n    animation: loading 1.5s linear infinite;\n}\n\n@keyframes loading {\n    from {left: -200px; width: 30%;}\n    50% {width: 30%;}\n    70% {width: 70%;}\n    80% { left: 50%;}\n    95% {left: 120%;}\n    to {left: 100%;}\n}\n", ""]);

// exports
